class SampleInfo {
    constructor(id, name, url, segments = 1) {
        this.id = id;
        this.name = name;
        this.url = url;
        this.segments = segments;
    }
    setDurationForPattern(duration) {
        this.durationForPattern = duration;
    }
}
export default SampleInfo;
export { SampleInfo, };
